import moment from 'moment';
import { createSelector } from 'reselect';

export const inputSelector = state => state.announcements;

export const allAnnouncements = state => Object.values(state.announcements.byId);

export const isLoadingSelector = createSelector(inputSelector, resourceState => resourceState.loading);

const calculateDisplayOrder = (announcement, groupId) => {
  if (announcement.system_announcement) return -100;
  const recipient = announcement.announcement_recipients.find(r => r.group_id === groupId) || {};
  return recipient.display_order || 1000;
};

const sortAnnouncements = (announcements, groupId) =>
  announcements.sort((a, b) => {
    const displayOrder1 = calculateDisplayOrder(a, groupId);
    const displayOrder2 = calculateDisplayOrder(b, groupId);
    return displayOrder1 - displayOrder2;
  });

export const filterAnnouncementByGroup = (announcements, groupId) => {
  announcements = sortAnnouncements(announcements, groupId);

  if (!groupId) return announcements;
  return announcements.filter(
    announcement =>
      announcement.system_announcement ||
      announcement.announcement_recipients.find(recipient => String(recipient.group_id) === String(groupId))
  );
};

const dashboardDateTime = state => state.dashboards.dashboardDatetime.dateTime;

// Returns all (non-trashed) announcements that are visible at the time set on
// the dashboard. This takes into account the publish from/to dates set on the
// announcement
export const announcementsAtDashboardTime = createSelector(
  allAnnouncements,
  dashboardDateTime,
  (announcements, dashboardTime) => {
    dashboardTime = moment(dashboardTime);

    return announcements.filter(announcement => {
      const { publish_from, publish_until, trashed_at } = announcement;
      if (trashed_at) return false; // ignore trashed announcements
      const afterPublishFrom = !publish_from || dashboardTime.isSameOrAfter(publish_from);
      const beforePublishUntil = !publish_until || dashboardTime.isBefore(publish_until);

      return afterPublishFrom && beforePublishUntil;
    });
  }
);
